export const BaseTaskListScenarioId = 'SpacesTaskList';
export const TaskListPickerDefaultMaxWidth = 150; // default max width if for some reason component rects are undefined
export const AssetContextMenuOffset = 76; // asset context menu and margins for calendar picker max width dynamic calcs
export const ButtonTextContainerOffset = 50; // offset to create ellipsis between picker label and full button
export const TaskListAssetActionSource = 'SpacesTaskListAsset';
export const TaskListAssetCategoryActionSource = 'BoardTaskListItemCallout';
